<mat-form-field>

  <mat-label *ngIf="label">{{label | translate}}</mat-label>
  <mat-label *ngIf="!label && placeholder"> {{placeholder | translate}}</mat-label>

  <div class="input">

    <input matInput
           [id]="id"
           [attr.tabindex]="tabindex"
           [formControl]="form"
           [placeholder]="placeholder | translate"
           [required]="form | controlRequired"
           [specialCharacters]="['-']"
           [validation]="true"
           [mask]="postalZoneMask"
           [autocomplete]="autocomplete">
  </div>

  <mat-error>
    {{ form?.errors | formError: refreshPipe }}
  </mat-error>

</mat-form-field>
